export default "__VITE_ASSET__0tZ68Xn3__"